import React, { useEffect } from 'react';

import ListIcon from '@material-ui/icons/FormatListNumbered';

import Card from '../../../common/card/Card';
import CardContent from '../../../common/card/CardContent';
import CardTitle from '../../../common/card/CardTitle';
import InlineForm from '../../../common/inline/InlineForm';
import InlineFormik from '../../../common/inline/InlineFormik';
import InlineRadioGroup from '../../../common/inline/InlineRadioGroup';
import InlineTextField from '../../../common/inline/InlineTextField';
import { useUpdateCapa } from '../Capa.hook';
import { Capa, BaseCapaCardProps } from '../Capa.interface';
import { useTaskEntityFields } from '../../workflow/Workflow.hooks';

export type CapaPreventiveCardProps = BaseCapaCardProps;

export const CapaPreventiveCard: React.FC<CapaPreventiveCardProps> = props => {
  const { capa, onChange, setErrorMessage, setSuccessMessage } = props;
  const { isFieldDisabled } = useTaskEntityFields(capa.task);
  const [{ data: updatedCapa, isLoading, error }, update] = useUpdateCapa(
    capa.id
  );

  useEffect(() => {
    if (updatedCapa?.id) setSuccessMessage('CAPA successfully updated');
  }, [setSuccessMessage, updatedCapa]);

  useEffect(() => {
    if (Boolean(error)) setErrorMessage('There was an error saving');
  }, [setErrorMessage, error]);

  if (!capa.id) return null;

  return (
    <InlineFormik
      initialValues={capa}
      isSubmitting={isLoading}
      error={error}
      onSubmit={(updatedValue: Partial<Capa>) => {
        update({
          ...updatedValue
        });
        onChange?.(updatedValue);
      }}
    >
      <Card>
        <CardTitle>
          <ListIcon />
          Preventive Action
        </CardTitle>
        <CardContent padding='large'>
          <InlineForm>
            <InlineTextField
              name='preventiveAction'
              label='Preventive Action'
              disabled={isFieldDisabled('preventiveAction')}
              multiline
            />
            <InlineRadioGroup
              isBoolean
              name='trainingNeeded'
              label='Training Needed'
              disabled={isFieldDisabled('trainingNeeded')}
              options={[
                { label: 'Yes', value: true },
                { label: 'No', value: false }
              ]}
            />
          </InlineForm>
        </CardContent>
      </Card>
    </InlineFormik>
  );
};

export default CapaPreventiveCard;
